import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import WithCenter from '../layout/WithCenter';

import { Dispatch } from '../../store';

import { isServiceConsole } from '../../helpers';

function AuthCallback() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch<Dispatch>();
  const [error, setError] = useState('');

  useEffect(() => {
    dispatch.auth
      .getUserInfo()
      .then(() => {
        if (isServiceConsole) {
          navigate('/admin/dashboard');
        } else {
          navigate('/');
        }
      })
      .catch(() => setError('There was an error with the request'));
  }, []);

  if (error) {
    return <WithCenter>{error}</WithCenter>;
  }

  return (
    <WithCenter>
      <h3>{t('loading')}</h3>
    </WithCenter>
  );
}

export default AuthCallback;
